<div *ngIf="zone === 'onboarding'" class="col element-zoom m-0" [ngStyle]="contentStyle">
  <div
    class="widget-wrapper"
    [ngClass]="isStepComplete ? 'step-complete' : isError ? 'error' : 'open'"
    [ngStyle]="borderStyle"
    style="min-height: 100%"
  >
    <div class="title-wrapper">
      <div class="title">
        <p [ngStyle]="colorTextAlignStyle" class="subtitle">
          <span [innerHTML]="widgetConfig.attributes['sub_heading'] | safeHtml"> </span>
        </p>
      </div>
      <div class="steps-count-wrapper">
        <span *ngIf="passwordForm.valid && isPassShowSuccessIcon" class="d-block">
          <img
            src="../../../../../../../../../assets/images/check-circle.svg"
            alt="check-circle"
            class="img-fluid"
          />
        </span>
        <span *ngIf="!isStepComplete && isError && isPassShowErrorIcon" class="d-block">
          <img
            (click)="showErrorMsg()"
            src="../../../../../../../../../assets/images/exclamation-circle.svg"
            alt="check-circle"
            class="cursor img-fluid"
          />
        </span>
      </div>
      <div *ngIf="!isStepComplete && isError && isShowErrorMsg" class="error-msg">
        <img
          src="../../../../../../../../../assets/images/exclamation-circle.svg"
          alt="check-circle"
          class="img-fluid"
        />
        <label>Password</label>
        <p>{{ errorMsg }}</p>
      </div>
    </div>
    <div class="form-wrapper">
      <form [formGroup]="passwordForm">
        @for (field of widgetConfig.attributes['field_attributes']; track field.name) {
        <div class="form-group">
          <ng-container *ngIf="field.type !== 'dropdown'">
            <div class="finx-input-parent position-relative">
              <finxone-platform-label-input
                [type]="field.type"
                class="profile-input"
                [label]="field.label"
                [formControlName]="field.name"
                [formGroup]="passwordForm"
                [labelAsPlaceholder]="pageConfig?.labelsAsPlaceholder"
                [textColor]="colorStyle"
                [colorTextAlignStyle]="colorTextAlignStyle"
                [textInputFontStyle]="textInputFontStyle"
                [inputStyle]="passwordInputFieldsStyle[field.name]"
                (focusEvent)="updateFieldStyles($event, field.name)"
              ></finxone-platform-label-input>
              <mat-icon
                *ngIf="field.type === 'password'"
                (click)="changePassType(field)"
                svgIcon="pass-eye"
              ></mat-icon>
              <mat-icon
                *ngIf="field.type === 'text'"
                (click)="changePassType(field)"
                svgIcon="pass-eye-hide"
              ></mat-icon>
            </div>
          </ng-container>
        </div>
        }
        <div class="error-wrapper" *ngIf="isError">
          <div class="text-error" *ngIf="passwordForm.get('password')?.invalid">
            <img
              src="../../../../../../../../../assets/images/exclamation-circle.svg"
              alt="check-circle"
              class="img-fluid"
            />
            <p>Password is a required field</p>
          </div>
          <div class="text-error" *ngIf="passwordForm.get('confirm_password')?.invalid">
            <img
              src="../../../../../../../../../assets/images/exclamation-circle.svg"
              alt="check-circle"
              class="img-fluid"
            />
            <p>Confirm password is a required field</p>
          </div>
          <div
            class="text-error"
            *ngIf="passwordForm.get('confirm_password')?.touched && passwordForm.hasError('noPassswordMatch')"
          >
            <img
              src="../../../../../../../../../assets/images/exclamation-circle.svg"
              alt="check-circle"
              class="img-fluid"
            />
            <p>Passwords do not match</p>
          </div>
        </div>
        @if(isShowPasswordRule || renderedPasswordRulesTemplate){
        <div class="password-validation-box" [ngStyle]="colorTextAlignStyle">
          @if(isShowPasswordRule ){
          <div class="row mx-0">
            <div class="col">
              <div class="field-radiobutton">
                <em
                  class="pi pi-circle-fill pi-circle-invalid"
                  *ngIf="
                    passwordForm.get('password')?.hasError('minlength') ||
                    passwordForm.get('password')?.value.length === 0
                  "
                ></em>
                <em
                  class="pi pi-circle-fill pi-circle-valid"
                  *ngIf="
                    !passwordForm.get('password')!.hasError('minlength') &&
                    passwordForm.get('password')?.value.length !== 0
                  "
                ></em>
                <label class="radio" for="min8char" [ngStyle]="colorTextAlignStyle">
                  &nbsp;&nbsp;Minimum Eight Characters&nbsp;&nbsp;
                </label>
              </div>
              <div class="field-radiobutton">
                <em
                  class="pi pi-circle-fill pi-circle-invalid"
                  *ngIf="
                    passwordForm.get('password')?.hasError('hasSmallCase') ||
                    passwordForm.get('password')?.value.length === 0
                  "
                ></em>
                <em
                  class="pi pi-circle-fill pi-circle-valid"
                  *ngIf="
                    !passwordForm.get('password')!.hasError('hasSmallCase') &&
                    passwordForm.get('password')?.value.length !== 0
                  "
                ></em>
                <label class="radio" for="lowercaseone" [ngStyle]="colorTextAlignStyle">
                  &nbsp;&nbsp;One Lowercase Letter&nbsp;&nbsp;
                </label>
              </div>
              <div class="field-radiobutton">
                <em
                  class="pi pi-circle-fill pi-circle-invalid"
                  *ngIf="
                    passwordForm.get('password')?.hasError('hasCapitalCase') ||
                    passwordForm.get('password')?.value.length === 0
                  "
                ></em>
                <em
                  class="pi pi-circle-fill pi-circle-valid"
                  *ngIf="
                    !passwordForm.get('password')!.hasError('hasCapitalCase') &&
                    passwordForm.get('password')?.value.length !== 0
                  "
                ></em>
                <label class="radio" for="upperone" [ngStyle]="colorTextAlignStyle">
                  &nbsp;&nbsp;One Uppercase Letter&nbsp;&nbsp;
                </label>
              </div>
              <div class="field-radiobutton">
                <em
                  class="pi pi-circle-fill pi-circle-invalid"
                  *ngIf="
                    passwordForm.get('password')?.hasError('hasNumber') ||
                    passwordForm.get('password')?.value.length === 0
                  "
                ></em>
                <em
                  class="pi pi-circle-fill pi-circle-valid"
                  *ngIf="
                    !passwordForm.get('password')!.hasError('hasNumber') &&
                    passwordForm.get('password')?.value.length !== 0
                  "
                ></em>
                <label class="radio" for="digitone" [ngStyle]="colorTextAlignStyle">
                  &nbsp;&nbsp;One Digit&nbsp;&nbsp;
                </label>
              </div>
              <div class="field-radiobutton">
                <em
                  class="pi pi-circle-fill pi-circle-invalid"
                  *ngIf="
                    passwordForm.get('password')?.hasError('hasSpecialCharacters') ||
                    passwordForm.get('password')?.value.length === 0
                  "
                ></em>
                <em
                  class="pi pi-circle-fill pi-circle-valid"
                  *ngIf="
                    !passwordForm.get('password')!.hasError('hasSpecialCharacters') &&
                    passwordForm.get('password')?.value.length !== 0
                  "
                ></em>
                <label class="radio" for="specialchareone" [ngStyle]="colorTextAlignStyle">
                  &nbsp;&nbsp;One Special Character&nbsp;&nbsp;
                </label>
              </div>
            </div>
          </div>
          }
          <div class="row mx-0">
            <div class="col" [innerHTML]="renderedPasswordRulesTemplate | safeHtml"></div>
          </div>
        </div>
        }
        <div
          class="form-group m-0 is-hidden"
          style="position: fixed; bottom: 1em; left: 1em; width: calc(100% - 2em)"
        >
          <finx-button
            type="button"
            class="btn w-100 mt-2"
            labeltext="Confirm"
            (click)="onSubmit()"
          ></finx-button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- profile desgin -->
<div *ngIf="zone !== 'onboarding'" class="col element-zoom profile-page" [ngStyle]="contentStyle">
  <div class="form-wrapper" [ngStyle]="borderStyle">
    <form [formGroup]="passwordForm">
      <div class="form-group" *ngFor="let field of fieldAttributesPassword">
        <label [ngStyle]="colorTextAlignStyle" for="fname" class="bold">{{ field.label }}</label>
        <ng-container *ngIf="field.type !== 'dropdown'">
          <div class="finx-input-parent position-relative">
            <finx-input
              [type]="field.type"
              class="profile-input"
              [formControlName]="field.name"
              placeholder="{{ field.label }}"
              [textInputFontStyle]="textInputFontStyle"
              [textInputBackgroundColor]="textInputBackgroundColor"
              [value]="passwordForm.get(field.name)?.value ?? ''"
              [label]="field.label"
              [labelAsPlaceholder]="pageConfig?.labelsAsPlaceholder"
              (keyup)="valueChangesTrigger()"
              ><mat-icon svgIcon="pass-eye"></mat-icon
            ></finx-input>
            <mat-icon
              *ngIf="field.type === 'password' || field.type === 'text'"
              (click)="changePassType(field)"
              [svgIcon]="field.type === 'password' ? 'pass-eye' : 'pass-eye-hide'"
            ></mat-icon>
          </div>
        </ng-container>
      </div>
      <div class="error-wrapper" *ngIf="isError">
        <div class="text-error" *ngIf="passwordForm.get('password')?.invalid">
          <img
            src="../../../../../../../../../assets/images/exclamation-circle.svg"
            alt="check-circle"
            class="img-fluid"
          />
          <p>Password is a required field</p>
        </div>
        <div class="text-error" *ngIf="passwordForm.get('confirm_password')?.invalid">
          <img
            src="../../../../../../../../../assets/images/exclamation-circle.svg"
            alt="check-circle"
            class="img-fluid"
          />
          <p>Confirm password is a required field</p>
        </div>
        <div
          class="text-error"
          *ngIf="passwordForm.get('confirm_password')?.touched && passwordForm.hasError('noPassswordMatch')"
        >
          <img
            src="../../../../../../../../../assets/images/exclamation-circle.svg"
            alt="check-circle"
            class="img-fluid"
          />
          <p>Passwords do not match</p>
        </div>
      </div>
    </form>
  </div>
</div>
